<template>
<div class="tw-text-sm font-normal">
  <template v-for="(value, $index) in field.datahash.options.values">
    <radio-display-one v-bind="$props" :value="value" :index="$index" />
  </template>
</div>
</template>
<script>
import RadioDisplayOne from './radio_display_one.vue';
export default {
  components: {RadioDisplayOne},
  props: ['field', 'form_result'],
}
</script>